<form
  (ngSubmit)="handleSubmit()"
  [class.submitted]="isSubmitting"
  [formGroup]="formComp.form"
  data-cy="form-layout__form"
>
  <mat-card
    appearance="outlined"
    class="form-layout flex-column flex-row-horizontal-space-around-vertical-fill"
  >
    @if (isLoading) {
      <mat-progress-bar class="element-loader" mode="indeterminate"></mat-progress-bar>
      <div class="loading-shade" data-cy="form-layout__form-loading"></div>
    }

    @if (isDialog) {
      <mat-card-header
        class="form-layout__header flex-row-horizontal-space-between-vertical-center"
      >
        <h2 mat-card-title mat-dialog-title data-cy="dialog-title">{{ pageTitle }}</h2>
        <app-button-close></app-button-close>
      </mat-card-header>
    }

    <mat-card-content
      class="form-layout__content"
      [class.no-stepper]="!hasStepper"
      [class.with-header]="formComp.hasHeader"
    >
      @if (entityIsNotFound) {
        <div class="empty-layout" data-cy="entity-not-found-container">
          <div class="not-found__container flex-column-center" data-cy="not-found-container">
            <mat-icon class="not-found__icon">error</mat-icon>
            <span class="not-found__title" i18n
              >{{ formNameFeatures?.translation?.capitalize() }} not found</span
            >
            <span class="not-found__subtitle" i18n
              >{{ formNameFeatures?.translation?.capitalize() }} with id "{{ id }}" is not found, it
              can't be edited</span
            >
            <button
              (click)="cancel()"
              type="button"
              class="not-found__button"
              data-cy="entity-not-found-button-list"
              matButton="filled"
              i18n
            >
              Back to list
            </button>
          </div>
        </div>
      } @else {
        <ng-content></ng-content>
      }
    </mat-card-content>

    @if (!entityIsNotFound) {
      <mat-card-actions class="form-layout__footer">
        <ng-content select="action-footer">
          <core-form-footer
            class="fill-row"
            [stepper]="stepper"
            (canceled)="cancel()"
            [isEditMode]="isEditMode"
            [submitting]="isSubmitting"
            [isReadonly]="readonly"
            [submitButtonText]="submitButtonText"
          ></core-form-footer>
        </ng-content>
      </mat-card-actions>
    }
  </mat-card>
</form>
